import React from 'react';
import { NewsCardItem } from './NewsCardItem';
import classNames from 'classnames';
import styled from '@benzinga/themetron';
import { WordpressPost } from '@benzinga/content-manager';

export interface NewsBlockWithFiltersProps {
  className?: string;
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  list: {
    nodes?: WordpressPost[];
    tab_title: string;
    limit: string;
    vertical_id: number;
  }[];
}

export const NewsBlockWithFilters = ({ activeIndex, className, list, setActiveIndex }: NewsBlockWithFiltersProps) => {
  const clickHandler = (index: number) => () => {
    if (activeIndex !== index) setActiveIndex(index);
  };

  return (
    <BlockWrapper className={classNames('block-wrapper', className)}>
      <div className="filter-tabs-wrapper">
        {Array.isArray(list) &&
          list.map((tab, i) => (
            <button
              className={classNames('tab', { [`active-tab`]: activeIndex === i })}
              key={i}
              onClick={clickHandler(i)}
            >
              {tab.tab_title}
            </button>
          ))}
      </div>
      <div className="cards-wrapper">
        {Array.isArray(list[activeIndex]?.nodes) &&
          list[activeIndex]?.nodes?.map(card => <NewsCardItem card={card} key={card.id} variant="compact" />)}
      </div>
    </BlockWrapper>
  );
};

const BlockWrapper = styled.div`
  &.block-wrapper {
    border: 1px solid #e1ebfa;
    border-radius: 4px;
  }

  .filter-tabs-wrapper {
    background-color: #3f83f80d;
    padding: 12px 16px;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 959px) {
      justify-content: flex-start;
    }
  }

  .tab {
    flex-shrink: 0;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    text-transform: uppercase;
    color: #99aecc;
    transition: 0.25s color ease-in-out;

    &:not(.active-tab):hover {
      color: #3f83f8;
    }
  }

  .active-tab {
    cursor: default;
    color: #3f83f8;
  }

  .cards-wrapper {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media screen and (max-width: 959px) {
      flex-wrap: wrap;
      column-count: 2;
      max-height: 216px;

      .compact {
        max-width: 50%;
      }
    }

    @media screen and (max-width: 567px) {
      flex-wrap: nowrap;
      max-height: unset;

      .compact {
        max-width: 100%;
      }
    }
  }
`;
